import React from "react";

import { CommentBox } from "../ReportsView";

const XBARReportCommentBox = (props) => {
  const { error, handleBlur, handleChange, ReportComment, submit, toggle } = props;

  return (
    <CommentBox
      cancel={toggle}
      error={error}
      onInputBlur={handleBlur}
      onInputChange={handleChange}
      placeholder="Please enter your comment"
      submit={submit}
      value={ReportComment}
    />
  );
};

export default XBARReportCommentBox;
